import { render } from "./French.vue?vue&type=template&id=357bae3f&ts=true"
import script from "./French.vue?vue&type=script&lang=ts"
export * from "./French.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__